// extracted by mini-css-extract-plugin
module.exports = {"noteCon":"ratingAddNotes_noteCon__2fefm","textBox":"ratingAddNotes_textBox__2_gIu","btnSubmit":"ratingAddNotes_btnSubmit__1A9p9"};